const buttons = [
  {
    displayFn: (data) => {
      // display this button only when custom columns have been created
      return data.model && data.model.get("_created") ? true : false;
    },
    label: "Restore Original",
    icon: null,
    className: "pull-left btn btn-danger remove",
    attributes: {
      type: "button",
      title:
        "Removes your custom configuration and returns the report to its original state",
      "data-event-category": "View Customization",
      "data-event-action": "Remove",
    },
  },
  {
    label: "Save",
    icon: null,
    className: "btn btn-emphasized",
    attributes: {
      type: "submit",
      title: "Save this configuration",
      "data-event-category": "View Customization",
      "data-event-action": "Save",
    },
  },
];

export { buttons as default };
